/** LookupEnums (LE) must align with their associated Lookups. The associated Lookups must be marked as immutable.
 * Name the enum for the LookupGroup's Code. Name the keys to align with the Lookup's Code. The values should align with the Lookup's Murn.
 */
export namespace LE {
  export enum DocumentCategory {
    Contract = "murn:insight:lookup/DocumentCategory/Contract",
    Project = "murn:insight:lookup/DocumentCategory/Project",
    Grant = "murn:insight:lookup/DocumentCategory/Grant",
    System = "murn:insight:lookup/DocumentCategory/System",
    SpendRequest = "murn:insight:lookup/DocumentCategory/SpendRequest",
    PurchaseOrder = "murn:insight:lookup/DocumentCategory/PurchaseOrder",
    ContractTaskOrder = "murn:insight:lookup/DocumentCategory/ContractTaskOrder",
    DeliverableAcceptanceForm = "murn:insight:lookup/DocumentCategory/DeliverableAcceptanceForm",
    Invoice = "murn:insight:lookup/DocumentCategory/Invoice",
  }
  export enum DocumentType {
    ContractTaskOrder = "murn:insight:lookup/DocumentType/ContractTaskOrder",
    Invoice = "murn:insight:lookup/DocumentType/Invoice",
    ETS205 = "murn:insight:lookup/DocumentType/FormETS205",
    PurchaseOrder = "murn:insight:lookup/DocumentType/PurchaseOrder",
    DeliverableAcceptance = "murn:insight:lookup/DocumentType/DeliverableAcceptanceForm",
    Check = "murn:insight:lookup/DocumentType/Check",
  }
  export enum InvoiceStatus {
    Paid = "murn:insight:lookup/InvoiceStatus/Paid",
  }
  export enum PaymentMethod {
    Check = "murn:insight:lookup/PaymentMethod/Check",
    PCard = "murn:insight:lookup/PaymentMethod/PCard",
  }
  export enum ContractStatus {
    Active = "murn:insight:lookup/ContractStatus/Active",
  }
}
